import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Text } from "../../../foundations/typography/Text/Text.js";
import { Button } from "../../action/Button/Button.js";
import { ModalContainer } from "../Modal/components/ModalContainer.js";
import { ModalFooter } from "../Modal/components/ModalFooter.js";
import { ModalHeader } from "../Modal/components/ModalHeader.js";
import { Modal } from "../Modal/Modal.js";
const confirmationDialog = "_confirmationDialog_1jk4e_3";
const confirmationDialogHeader = "_confirmationDialogHeader_1jk4e_31";
const confirmationDialogBody = "_confirmationDialogBody_1jk4e_35";
const confirmationDialogFooter = "_confirmationDialogFooter_1jk4e_41";
const confirmationDialogButton = "_confirmationDialogButton_1jk4e_52";
const confirmationDialogEntering = "_confirmationDialogEntering_1jk4e_56";
const confirmationDialogExiting = "_confirmationDialogExiting_1jk4e_66";
const styles = {
  confirmationDialog,
  confirmationDialogHeader,
  confirmationDialogBody,
  confirmationDialogFooter,
  confirmationDialogButton,
  confirmationDialogEntering,
  confirmationDialogExiting
};
const ConfirmationDialog = ({
  cancelButton,
  confirmButton,
  children,
  dialogTitle,
  isOpen,
  isAlertDialog,
  renderIn,
  restoreFocus = true,
  onCancel,
  onConfirm,
  requiresExplicitChoice,
  closeButtonDescription
}) => {
  return /* @__PURE__ */ jsx(
    Modal,
    {
      "aria-label": dialogTitle,
      restoreFocus,
      isDismissable: !requiresExplicitChoice,
      onClose: onCancel,
      renderIn,
      isOpen,
      transitionStyles: {
        entering: styles.confirmationDialogEntering,
        exiting: styles.confirmationDialogExiting
      },
      children: /* @__PURE__ */ jsxs(
        ModalContainer,
        {
          role: isAlertDialog ? "alertdialog" : "dialog",
          className: styles.confirmationDialog,
          component: "div",
          "aria-modal": true,
          children: [
            /* @__PURE__ */ jsx(
              ModalHeader,
              {
                className: styles.confirmationDialogHeader,
                closeButtonDescription,
                children: dialogTitle
              }
            ),
            /* @__PURE__ */ jsx("div", { className: styles.confirmationDialogBody, children: typeof children === "string" ? /* @__PURE__ */ jsx(Text, { component: "span", children }) : /* @__PURE__ */ jsx(Fragment, { children }) }),
            /* @__PURE__ */ jsxs(ModalFooter, { className: styles.confirmationDialogFooter, children: [
              /* @__PURE__ */ jsx(
                Button,
                {
                  className: styles.confirmationDialogButton,
                  variant: "primary",
                  size: "medium",
                  component: "button",
                  onPress: onConfirm,
                  children: confirmButton
                }
              ),
              /* @__PURE__ */ jsx(
                Button,
                {
                  className: styles.confirmationDialogButton,
                  variant: "outline",
                  size: "medium",
                  component: "button",
                  onPress: onCancel,
                  children: cancelButton
                }
              )
            ] })
          ]
        }
      )
    }
  );
};
export {
  ConfirmationDialog
};
